import type {CmLogger} from "@cm/log"
import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import type {NodeId, NodeClassImpl} from "#template/runtime-graph/types"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"

const TD = TypeDescriptors

const traceDescriptor = {
    input: TD.inlet(TD.Identity<any>()),
    key: TD.inlet(TD.Primitive<string>()),
    logger: TD.inlet(TD.Identity<CmLogger>()),
    output: TD.outlet(TD.Identity<any>()),
}

export class Trace<T> implements NodeClassImpl<typeof traceDescriptor, typeof Trace> {
    static descriptor = traceDescriptor
    static uniqueName = "Trace"
    input!: Inlet<T>
    key!: Inlet<string>
    logger!: Inlet<CmLogger>
    output!: Outlet<T>
    $id?: NodeId

    run() {
        const value = this.input
        if (this.key !== NotReady && this.logger !== NotReady) {
            const msg = this.key ?? `Trace[${this.$id}`
            this.logger.log(msg, value)
        }
        this.output.emit(value)
    }
}
